import { useQuery } from '@tanstack/react-query';
import { UseQueryOptions } from '@tanstack/react-query';
import { ClubService } from '../club.service';

export const useGetClubs = (
	params?: Clubs.ClubParams,
	options?: Omit<
		UseQueryOptions<Clubs.GetClubsResponse, Error>,
		'queryKey' | 'queryFn'
	>,
) => {
	return useQuery({
		queryKey: ['clubs', params],
		queryFn: () => ClubService.get(params),
		refetchOnWindowFocus: false,
		...options,
	});
};

export const useGetClubsB2B2C = (
	options?: Omit<
		UseQueryOptions<Clubs.GetClubsResponse, Error>,
		'queryKey' | 'queryFn'
	>,
) => {
	return useGetClubs({ shelf: 'B2B2C' }, options);
};

export const useGetClubsB2C = (
	options?: Omit<
		UseQueryOptions<Clubs.GetClubsResponse, Error>,
		'queryKey' | 'queryFn'
	>,
) => {
	return useGetClubs({ shelf: 'B2C' }, options);
};

export const useGetMyClub = (
	options?: Omit<UseQueryOptions<any, Error>, 'queryKey' | 'queryFn'>,
) => {
	return useQuery({
		queryKey: ['clubs', 'me'],
		queryFn: () => ClubService.getMe(),
		refetchOnWindowFocus: false,
		...options,
	});
};

export const useGetClubsAvailable = (
	options?: Omit<
		UseQueryOptions<Clubs.Club[], Error>,
		'queryKey' | 'queryFn'
	>,
) => {
	return useQuery({
		queryKey: ['clubs', 'available'],
		queryFn: () => ClubService.getAvailable(),
		refetchOnWindowFocus: false,
		...options,
	});
};

export const useGetUserBenefitsBalance = (
	userId: string,
	params?: Clubs.GetUserBenefitsBalanceParams,
	options?: Omit<
		UseQueryOptions<Clubs.UserBenefitsBalanceResponse, Error>,
		'queryKey' | 'queryFn'
	>,
) => {
	return useQuery({
		queryKey: ['clubs', 'user-benefits-balance', userId, params],
		queryFn: () => ClubService.getUserBenefitsBalance(userId, params),
		refetchOnWindowFocus: false,
		enabled: !!userId,
		...options,
	});
};

export const useGetUserClubHistory = (
	userId: string,
	params?: Clubs.GetUserClubHistoryParams,
	options?: Omit<
		UseQueryOptions<Clubs.PaginatedClubTimelineResponse, Error>,
		'queryKey' | 'queryFn'
	>,
) => {
	return useQuery({
		queryKey: ['clubs', 'user-history', userId, params],
		queryFn: () => ClubService.getUserClubHistory(userId, params),
		refetchOnWindowFocus: false,
		enabled: !!userId,
		...options,
	});
};
